const normalizeMenuCategoryName = (value: unknown) =>
  String(value || "")
    .toLowerCase()
    .replace(/&amp;/g, "&")
    .replace(/[^a-z0-9]+/g, " ")
    .trim();

export function findMenuChildCategory(parent: any, ...names: string[]) {
  const children = Array.isArray(parent?.categories) ? parent.categories : [];

  for (const rawName of names) {
    const term = normalizeMenuCategoryName(rawName);
    const exact = children.find(
      (category: any) => normalizeMenuCategoryName(category?.name) === term
    );
    if (exact) return exact;

    const wantedTokens = term.split(" ").filter(Boolean);
    const tokenMatch = children.find((category: any) => {
      const tokens = new Set(
        normalizeMenuCategoryName(category?.name).split(" ").filter(Boolean)
      );
      return wantedTokens.every((token) => tokens.has(token));
    });
    if (tokenMatch) return tokenMatch;
  }

  return undefined;
}
